module.exports = __webpack_public_path__ + "static/media/stay-home.9de85f81.svg";